// extracted by mini-css-extract-plugin
export var blue = "_2r-f";
export var brand = "_2r-b";
export var darkGrey = "_2r-e";
export var disabled = "_2r-4";
export var disabledSubtle = "_2r-5";
export var error = "_2r-6";
export var green = "_2r-g";
export var grey = "_2r-d";
export var icon = "_2r-0";
export var inherit = "_2r-a";
export var lightGrey = "_2r-c";
export var orange = "_2r-i";
export var pink = "_2r-k";
export var primary = "_2r-1";
export var purple = "_2r-l";
export var red = "_2r-j";
export var secondary = "_2r-2";
export var success = "_2r-9";
export var tertiary = "_2r-3";
export var warning = "_2r-7";
export var warningSecondary = "_2r-8";
export var white = "_2r-m";
export var yellow = "_2r-h";